import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../common/containers/icon';
const documentID = document => typeof document === 'string' ? document : document && document.id;
const documentLabel = (document, options) => {
  const id = documentID(document);
  const match = options.find(option => option && option.id === id);
  if (match && match.displayName) {
    return match.displayName;
  }
  if (document && document.displayName) {
    return document.displayName;
  }
  return id;
};
const CertificationDocumentLinks = ({
  documents: _documents = [],
  options: _options = []
}) => {
  const links = _documents.map(document => ({
    id: documentID(document),
    label: documentLabel(document, _options)
  })).filter(({
    id
  }) => Boolean(id));
  if (links.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled t-cf-document-links"
  }, links.map(({
    id,
    label
  }) => /*#__PURE__*/React.createElement("li", {
    key: id
  }, /*#__PURE__*/React.createElement("a", {
    href: `#/library/${encodeURIComponent(String(id))}`,
    target: "_blank",
    rel: "noopener noreferrer",
    title: `View ${label}`
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "file-alt"
  }), " ", label))));
};
CertificationDocumentLinks.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])),
  options: PropTypes.arrayOf(PropTypes.shape({}))
};
export default CertificationDocumentLinks;